import type { ReactNode } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  type Breakpoint,
} from '@mui/material';
import { ApiErrorAlert } from '../ApiErrorAlert';

export interface FormDialogProps {
  open: boolean;
  title: ReactNode;
  onClose: () => void;
  /** Genellikle `form.handleSubmit(mutate)`. */
  onSubmit: () => void;
  submitting: boolean;
  error?: unknown;
  children: ReactNode;
  submitLabel?: string;
  cancelLabel?: string;
  maxWidth?: Breakpoint;
  fullWidth?: boolean;
  disableSubmit?: boolean;
  /** Sola hizalı ek aksiyon (ör. düzenleme modunda "Sil"). */
  extraActions?: ReactNode;
}

/** Tüm create/edit form diyaloglarının ortak kroması — `DemandFormDialog`'un
 *  genelleştirilmiş, geriye uyumlu hâli. Form durumu (RHF/zod/mutasyon) çağırana ait;
 *  bu bileşen yalnız Dialog + başlık + gövde + aksiyonlar + hata çubuğu sunar. */
export function FormDialog({
  open,
  title,
  onClose,
  onSubmit,
  submitting,
  error,
  children,
  submitLabel = 'Kaydet',
  cancelLabel = 'Vazgeç',
  maxWidth = 'sm',
  fullWidth = true,
  disableSubmit = false,
  extraActions,
}: FormDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={() => !submitting && onClose()}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {children}
          <ApiErrorAlert error={error} />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        {extraActions}
        <Stack direction="row" spacing={1} sx={{ ml: 'auto' }}>
          <Button onClick={onClose} disabled={submitting}>
            {cancelLabel}
          </Button>
          <Button onClick={onSubmit} variant="contained" disabled={submitting || disableSubmit}>
            {submitting ? 'Kaydediliyor…' : submitLabel}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
